import * as dateFns from "date-fns";
import { useParams } from "@tanstack/react-router";
import { DEFAULT_LOCALE } from "@bfc-software/bfc-web-ui/i18n";

export function DateValue({
  dateValue,
}: {
  dateValue: string | null | undefined;
}) {
  const params = useParams({ from: "/$lang/_layout" });

  if (typeof dateValue !== "string") {
    return <></>;
  }

  // TODO: Localized dates.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const localeSlug = params.lang ?? DEFAULT_LOCALE;

  const normalized = dateFns.parseISO(dateValue);

  return (
    <div>
      <span>{dateFns.format(normalized, "PP p")}</span>
    </div>
  );
}
